import { defaultSearchClient, env } from './algolia'

export const algoliaTemplatesIndex = env(
  process.env.NEXT_PUBLIC_ALGOLIA_TEMPLATES_INDEX || process.env.VITE_ALGOLIA_TEMPLATES_INDEX,
  'NEXT_PUBLIC_ALGOLIA_TEMPLATES_INDEX or VITE_ALGOLIA_TEMPLATES_INDEX is not set',
)

export async function getObjectById<T = Record<string, unknown>>(
  objectId: string,
): Promise<T | null> {
  try {
    return await defaultSearchClient.getObject<T>({
      indexName: algoliaTemplatesIndex,
      objectID: objectId,
    })
  } catch (error) {
    return null
  }
}
